import React from 'react'
import { Route, IndexRoute, IndexRedirect } from 'react-router'

import ListCategories from '../components/categories/product-list'
import CreateCategory from '../components/categories/create'
import EditCategory from '../components/categories/edit'

import ListProductCategories from '../components/product-categories/list'
import CreateProductCategory from '../components/product-categories/create'
import EditProductCategory from '../components/product-categories/edit'
import ProductCategoryImport from '../components/ProductCategoryImportPage'

import ListCategoryDiscounts from '../components/category-discounts/list'
import CreateCategoryDiscount from '../components/category-discounts/create'
import EditCategoryDiscount from '../components/category-discounts/edit'

import ListProductDiscounts from '../components/product-discounts/list'
import CreateProductDiscount from '../components/product-discounts/create'
import EditProductDiscount from '../components/product-discounts/edit'

import ListPromoCodes from '../components/promo-codes/list'
import CreatePromoCode from '../components/promo-codes/create'
import ShowPromoCode from '../components/promo-codes/show'
import EditPromoCode from '../components/promo-codes/edit'
import PromoCodeDiscountsForPromoCode from '../components/promo-codes/discounts'
import CreatePromoCodeDiscountForPromoCode from '../components/promo-codes/discounts-create'

import ListPromoCodeDiscounts from '../components/promo-code-discounts/list'
import CreatePromoCodeDiscount from '../components/promo-code-discounts/create'
import EditPromoCodeDiscount from '../components/promo-code-discounts/edit'

import ListDiscounts from '../components/discounts/list'
import CreateDiscount from '../components/discounts/create'
import ShowDiscount from '../components/discounts/show'
import EditDiscount from '../components/discounts/edit'

import ListProducts from '../components/products/list'
import CreateProduct from '../components/products/create'
import ShowProduct from '../components/products/show'
import EditProduct from '../components/products/edit'

import ListOrders from '../components/orders/list'
import CreateOrder from '../components/orders/create'
import ShowOrder from '../components/orders/show'
import EditOrder from '../components/orders/edit'
import ManageOrder from '../components/orders/manage'
import Invoice from '../components/orders/manage/editInvoice'

import ListOrderItems from '../components/orders/order-items/list'
import CreateOrderItem from '../components/orders/order-items/create'
import EditOrderItem from '../components/orders/order-items/edit'

import ListOrderDiscounts from '../components/orders/discounts/list'
import CreateOrderDiscount from '../components/orders/discounts/create'
import EditOrderDiscount from '../components/orders/discounts/edit'

import ListTransactions from '../components/transactions/list'

const EcommerceRoutes = (
  <Route path='ecommerce'>
    <Route path='orders'>
      <IndexRoute component={ListOrders} />
      <Route path='create' component={CreateOrder} />

      <Route path=':orderId' component={ShowOrder}>
        <IndexRedirect to='edit' />
        <Route path='edit' component={EditOrder} />

        <Route path='manage' component={ManageOrder} />

        <Route path='items' component={ListOrderItems} />
        <Route path='items/create' component={CreateOrderItem} />
        <Route path='items/:orderItemId/edit' component={EditOrderItem} />

        <Route path='discounts' component={ListOrderDiscounts} />
        <Route path='discounts/create' component={CreateOrderDiscount} />
        <Route path='discounts/:orderDiscountId/edit' component={EditOrderDiscount} />

        <Route path='invoice' component={Invoice} />
      </Route>
    </Route>

    <Route path='products'>
      <IndexRoute component={ListProducts} />
      <Route path='create' component={CreateProduct} />
      <Route path='import-product-categories' component={ProductCategoryImport} />

      <Route path=':productId' component={ShowProduct}>
        <IndexRedirect to='edit' />
        <Route path='edit' component={EditProduct} />
      </Route>
    </Route>

    <Route path='discounts'>
      <IndexRoute component={ListDiscounts} />
      <Route path='create' component={CreateDiscount} />
      <Route path=':discountId' component={ShowDiscount}>
        <Route path='edit' component={EditDiscount} />
      </Route>
    </Route>

    <Route path='categories'>
      <IndexRoute component={ListCategories} />
      <Route path='create' component={CreateCategory} />
      <Route path=':categoryId' component={EditCategory}>
        <Route path='edit' component={EditCategory} />
      </Route>
    </Route>

    <Route path='product-categories'>
      <IndexRoute component={ListProductCategories} />
      <Route path='create' component={CreateProductCategory} />
      <Route path=':productCategoryId' component={EditProductCategory}>
        <Route path='edit' component={EditProductCategory} />
      </Route>
    </Route>

    <Route path='product-discounts'>
      <IndexRoute component={ListProductDiscounts} />
      <Route path='create' component={CreateProductDiscount} />
      <Route path=':productDiscountId' component={EditProductDiscount}>
        <Route path='edit' component={EditProductDiscount} />
      </Route>
    </Route>

    <Route path='category-discounts'>
      <IndexRoute component={ListCategoryDiscounts} />
      <Route path='create' component={CreateCategoryDiscount} />
      <Route path=':categoryDiscountId' component={EditCategoryDiscount}>
        <Route path='edit' component={EditCategoryDiscount} />
      </Route>
    </Route>

    <Route path='promo-codes'>
      <IndexRoute component={ListPromoCodes} />
      <Route path='create' component={CreatePromoCode} />
      <Route path=':promoCodeId' component={ShowPromoCode}>
        <Route path='edit' component={EditPromoCode} />
        <Route path='discounts' component={PromoCodeDiscountsForPromoCode} />
        <Route path='discounts/create' component={CreatePromoCodeDiscountForPromoCode} />
      </Route>
    </Route>

    <Route path='promo-code-discounts'>
      <IndexRoute component={ListPromoCodeDiscounts} />
      <Route path='create' component={CreatePromoCodeDiscount} />
      <Route path=':promoCodeDiscountId' component={EditPromoCodeDiscount}>
        <Route path='edit' component={EditPromoCodeDiscount} />
      </Route>
    </Route>

    <Route path='transactions'>
      <IndexRoute component={ListTransactions} />
    </Route>
  </Route>
)

export default EcommerceRoutes
